"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _createForOfIteratorHelper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AsyncScheduler_1 = require("../scheduler/AsyncScheduler");

var IntervalScheduler_1 = require("../scheduler/IntervalScheduler");

var SignalingClientEventType_1 = require("../signalingclient/SignalingClientEventType");

var SignalingProtocol_js_1 = require("../signalingprotocol/SignalingProtocol.js");

var Types_1 = require("../utils/Types");
/**
 * [[DefaultPingPong]] implements the PingPong and SignalingClientObserver interface.
 */


var DefaultPingPong = /*#__PURE__*/function () {
  function DefaultPingPong(signalingClient, intervalMs, logger) {
    _classCallCheck(this, DefaultPingPong);

    this.signalingClient = signalingClient;
    this.intervalMs = intervalMs;
    this.logger = logger;
    this.observerQueue = new Set();
    this.consecutivePongsUnaccountedFor = 0;
    this.intervalScheduler = new IntervalScheduler_1.default(this.intervalMs);
    this.pingId = 0;
  }

  _createClass(DefaultPingPong, [{
    key: "addObserver",
    value: function addObserver(observer) {
      this.logger.info('adding a ping-pong observer');
      this.observerQueue.add(observer);
    }
  }, {
    key: "removeObserver",
    value: function removeObserver(observer) {
      this.logger.info('removing a ping-pong observer');
      this.observerQueue.delete(observer);
    }
  }, {
    key: "forEachObserver",
    value: function forEachObserver(observerFunc) {
      var _this = this;

      var _iterator = _createForOfIteratorHelper(this.observerQueue),
          _step;

      try {
        var _loop = function _loop() {
          var observer = _step.value;
          AsyncScheduler_1.default.nextTick(function () {
            if (_this.observerQueue.has(observer)) {
              observerFunc(observer);
            }
          });
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "start",
    value: function start() {
      this.stop();
      this.signalingClient.registerObserver(this);

      if (this.signalingClient.ready()) {
        this.startPingInterval();
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      this.stopPingInterval();
      this.signalingClient.removeObserver(this);
    }
  }, {
    key: "startPingInterval",
    value: function startPingInterval() {
      var _this2 = this;

      this.intervalScheduler.start(function () {
        _this2.ping();
      });
      this.ping();
    }
  }, {
    key: "stopPingInterval",
    value: function stopPingInterval() {
      this.intervalScheduler.stop();
      this.pingId = 0;
      this.consecutivePongsUnaccountedFor = 0;
    }
  }, {
    key: "ping",
    value: function ping() {
      var _this3 = this;

      if (this.consecutivePongsUnaccountedFor > 0) {
        this.logger.warn("missed pong ".concat(this.consecutivePongsUnaccountedFor, " time(s)"));
        this.forEachObserver(function (observer) {
          Types_1.Maybe.of(observer.didMissPongs).map(function (f) {
            return f.bind(observer)(_this3.consecutivePongsUnaccountedFor);
          });
        });
      }

      this.consecutivePongsUnaccountedFor += 1;
      this.pingId = this.pingId + 1 & 0xffffffff;
      var ping = SignalingProtocol_js_1.SdkPingPongFrame.create();
      ping.pingId = this.pingId;
      ping.type = SignalingProtocol_js_1.SdkPingPongType.PING;
      this.pingTimestampLocalMs = this.signalingClient.pingPong(ping);
      this.logger.debug(function () {
        return "sent ping ".concat(_this3.pingId);
      });
    }
  }, {
    key: "pong",
    value: function pong(pingId) {
      var pong = SignalingProtocol_js_1.SdkPingPongFrame.create();
      pong.pingId = pingId;
      pong.type = SignalingProtocol_js_1.SdkPingPongType.PONG;
      this.signalingClient.pingPong(pong);
    }
  }, {
    key: "handleSignalingClientEvent",
    value: function handleSignalingClientEvent(event) {
      switch (event.type) {
        case SignalingClientEventType_1.default.WebSocketOpen:
          this.startPingInterval();
          break;

        case SignalingClientEventType_1.default.WebSocketFailed:
        case SignalingClientEventType_1.default.WebSocketError:
          this.logger.warn("stopped pinging (".concat(SignalingClientEventType_1.default[event.type], ")"));
          this.stopPingInterval();
          break;

        case SignalingClientEventType_1.default.WebSocketClosing:
        case SignalingClientEventType_1.default.WebSocketClosed:
          this.logger.info("stopped pinging (".concat(SignalingClientEventType_1.default[event.type], ")"));
          this.stopPingInterval();
          break;

        case SignalingClientEventType_1.default.ReceivedSignalFrame:
          if (event.message.type !== SignalingProtocol_js_1.SdkSignalFrame.Type.PING_PONG) {
            break;
          }

          if (event.message.pingPong.type === SignalingProtocol_js_1.SdkPingPongType.PONG) {
            var pingId = event.message.pingPong.pingId;

            if (pingId !== this.pingId) {
              this.logger.warn("unexpected ping id ".concat(pingId, " (expected ").concat(this.pingId, ")"));
              break;
            }

            this.consecutivePongsUnaccountedFor = 0;
            var pongTimestampRemoteMs;

            if (typeof event.message.timestampMs === 'number') {
              pongTimestampRemoteMs = event.message.timestampMs;
            } else {
              break;
            }

            this.logger.debug(function () {
              return "received pong ".concat(pingId, " with timestamp ").concat(pongTimestampRemoteMs);
            });
            var pongTimestampLocalMs = event.timestampMs;
            var pingPongLocalIntervalMs = pongTimestampLocalMs - this.pingTimestampLocalMs;
            var estimatedPingTimestampRemoteMs = Math.round(pongTimestampRemoteMs - pingPongLocalIntervalMs / 2);
            var estimatedClockSkewMs = this.pingTimestampLocalMs - estimatedPingTimestampRemoteMs;
            this.logger.info("local clock skew estimate=".concat(estimatedClockSkewMs, "ms from ping-pong time=").concat(pingPongLocalIntervalMs, "ms"));
            this.forEachObserver(function (observer) {
              Types_1.Maybe.of(observer.didReceivePong).map(function (f) {
                return f.bind(observer)(pingId, estimatedClockSkewMs, pingPongLocalIntervalMs);
              });
            });
          } else {
            this.pong(event.message.pingPong.pingId);
          }

          break;
      }
    }
  }]);

  return DefaultPingPong;
}();

exports.default = DefaultPingPong;